import { render } from "./AppFooter.vue?vue&type=template&id=47a4b8e4&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=47a4b8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a4b8e4"]])

export default __exports__